<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { __color } from "@zyzgroup/core-web";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
    colorEnd?: string;
    isGradient?: boolean;
  }>(),
  {
    isGradient: false
  }
);

const mappedState = mapState(["color.redCommon", "color.redGradientCommon"]);

const color = ref();
const colorEnd = ref();
const oppositeColor = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.redCommon"].value;
  colorEnd.value =
    props.colorEnd ||
    (props.isGradient
      ? mappedState["color.redGradientCommon"].value
      : color.value);
  oppositeColor.value = __color.set(color.value).opposite(true).toString();
});
</script>

<template>
  <!-- 不设置 width height , 自适应父元素 -->
  <!-- origin viewBox : x y width height : 0 0 24 24 , 目前 viewBox 是为了切除四周多余空白 -->
  <svg
    viewBox="4 4 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <defs>
      <!-- 对于同一个id，浏览器可能会渲染优化，导致后面更新的linearGradient不起作用 -->
      <linearGradient
        :id="`icon_warn_${color}_${colorEnd}`"
        x1="12"
        y1="4"
        x2="12"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          :stop-color="color"
        />
        <stop
          offset="1"
          :stop-color="colorEnd"
        />
      </linearGradient>
    </defs>
    <!-- 背景圆 -->
    <circle
      cx="12"
      cy="12"
      r="8"
      :fill="`url(#icon_warn_${color}_${colorEnd})`"
    />
    <!-- 竖线 -->
    <path
      d="M11.4666 8.80006C11.4666 8.50551 11.7053 8.26672 11.9999 8.26672C12.2944 8.26672 12.5332 8.50551 12.5332 8.80006V13.0667C12.5332 13.3613 12.2944 13.6001 11.9999 13.6001C11.7053 13.6001 11.4666 13.3613 11.4666 13.0667V8.80006Z"
      :fill="oppositeColor"
    />
    <!-- 小圆点 -->
    <path
      d="M11.4666 15.2001C11.4666 14.9055 11.7053 14.6667 11.9999 14.6667C12.2944 14.6667 12.5332 14.9055 12.5332 15.2001C12.5332 15.4946 12.2944 15.7334 11.9999 15.7334C11.7053 15.7334 11.4666 15.4946 11.4666 15.2001Z"
      :fill="oppositeColor"
    />
  </svg>
</template>
